module.exports = "../../../../platform/assets/pageMainIcon/business_baobiaochaxunlei6.svg";